const Diamond = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="diamond-01">
      <path
        id="Icon"
        d="M3.33272 12.1816H28.666M13.3327 4.18164L10.666 12.1816L15.9994 27.515L21.3327 12.1816L18.666 4.18164M16.8188 27.1983L28.7637 12.8645C28.9661 12.6216 29.0673 12.5001 29.106 12.3645C29.1401 12.245 29.1401 12.1183 29.106 11.9988C29.0673 11.8632 28.9661 11.7417 28.7637 11.4988L22.9859 4.56544C22.8683 4.42437 22.8095 4.35383 22.7375 4.30312C22.6736 4.25818 22.6024 4.22482 22.527 4.20453C22.4419 4.18164 22.3501 4.18164 22.1664 4.18164H9.83232C9.64867 4.18164 9.55685 4.18164 9.47176 4.20453C9.39637 4.22482 9.32513 4.25818 9.26128 4.30312C9.18923 4.35383 9.13044 4.42437 9.01288 4.56544L3.2351 11.4988C3.03266 11.7417 2.93144 11.8632 2.89276 11.9987C2.85866 12.1183 2.85866 12.245 2.89276 12.3645C2.93144 12.5001 3.03266 12.6216 3.2351 12.8645L15.1799 27.1983C15.4614 27.536 15.6021 27.7049 15.7705 27.7664C15.9183 27.8204 16.0805 27.8204 16.2282 27.7664C16.3967 27.7049 16.5374 27.536 16.8188 27.1983Z"
        stroke="#4C1D95"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Diamond;
